import type { Guide, GuideRecordHint } from '../types';

/**
 * S-24.10-01 — panel „Do zrobienia” i czynności po obsadzeniu na karcie zlecenia (makieta FTL p. Mariusza,
 * panel zlecenia; scenariusz e2e 26). DEMO/2026/10/H03 jest obsadzone autem DEMO 003 i ma zaznaczony
 * „Timeslot”, DEMO/2026/10/007 — wariant planisty i uwagę od FTL (`e2e/setup/scenario-state.mjs`).
 * Nagrywarka niczego nie zaznacza.
 */
const ASSIGNED: GuideRecordHint = {
  description: 'zlecenie obsadzone pojazdem floty, które nie jest jeszcze zrealizowane',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'FTL' },
};
const WITH_VARIANTS: GuideRecordHint = {
  description: 'zlecenie w planowaniu FTL z wariantem pojazdu, jeszcze bez obsadzenia',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'FTL' },
};

export const guide: Guide = {
  flagKey: 'orderChecklist',
  title: 'Panel „Do zrobienia” i czynności po obsadzeniu',
  whatItDoes:
    'W oknie zlecenia, pod alertami, panel „Do zrobienia” zbiera to, co trzeba zrobić przy zleceniu: braki prezlecenia, ryzyko, utratę pojazdu, alert przeplanowania, brak wariantu (z przejściem do rekomendacji), warianty czekające na Team Leadera, wniosek po wyjeździe na załadunek, pracę w Trade i otwarte uwagi od FTL. Przy obsadzonym zleceniu jest lista czynności z makiety: Timeslot, Alokacja (numer pojazdu, kierowca, nr terminala Trimble), Awizacja odbiorcy i Instrukcje dla kierowcy. Zaznacza planowanie FTL — kto i kiedy widać przy czynności i w historii zlecenia; nic nie wychodzi na zewnątrz. Zmiana pojazdu zaczyna listę od nowa.',
  audience: ['planista FTL', 'Team Leader (planista główny)', 'trader i gość — podgląd'],
  presentationItems: ['S-24.10-01'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: ASSIGNED,
      target: 'order-todo',
      title: 'Panel „Do zrobienia”',
      description:
        'Nad sekcjami okna zlecenia panel mówi, co zostało do zrobienia przy tym zleceniu. Bez pozycji — „Nic do zrobienia”.',
      action: 'Otwórz zlecenie i spójrz na panel pod alertami.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/H03' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: ASSIGNED,
      target: 'order-checklist',
      title: 'Czynności po obsadzeniu',
      description:
        'Cztery czynności z makiety. Przy wykonanej widać, kto i kiedy ją zaznaczył; wpis trafia też do historii zlecenia. Awizację robi CS, instrukcje przekazuje Odys — aplikacja niczego nie wysyła.',
      action: 'Zaznacz wykonaną czynność. Odznaczenie też zostaje w historii.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/H03' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: ASSIGNED,
      target: 'order-checklist-allocation',
      title: '„Alokacja” z kartoteki',
      description:
        'Przy alokacji stoją numer pojazdu, kierowca i numer terminala Trimble z kartoteki pojazdu. Brak w kartotece — kreska.',
      action: 'Sprawdź dane przy „Alokacja pojazdu i kierowcy” przed zaznaczeniem.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/H03' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: WITH_VARIANTS,
      target: 'order-todo-link-*',
      title: 'Warianty do decyzji',
      description:
        'Team Leader widzi „Do decyzji” z przyciskiem „Obsadź z wariantów”, który przewija do wariantów; planista — „Czeka na Team Leadera”. Otwarta uwaga od FTL też jest pozycją panelu.',
      action: 'Kliknij przycisk przy pozycji, żeby przejść do sekcji, w której się działa.',
      recorder: { account: 'master', demo: { kind: 'order', number: 'DEMO/2026/10/007' } },
    },
  ],
};
